import React from 'react'
import { Modal } from '../../../../../components/Modal/Modal'
import { useNavigate } from 'react-router-dom'
import { useDeleteRoomSession } from '../hooks/api'
import { useAppSelector } from '../../../../../store/hooks'
import { selectRoomSession, selectRoomSessionDeleteIsLoading } from '../../../../../store/meetingSummary/roomSession'
import { TrackEvent, useTracking } from '../../common/tracking'
import { getRoomTrackingDetails } from '../../tracking'

export interface DeleteMeetingModalProps {
  show: boolean
  onHide: () => void
}

export const DeleteMeetingModal: React.FC<DeleteMeetingModalProps> = ({ show, onHide }) => {
  const navigate = useNavigate()
  const { tracked } = useTracking()

  const roomSession = useAppSelector(selectRoomSession)
  const isDeleteRoomSessionLoading = useAppSelector(selectRoomSessionDeleteIsLoading)

  const deleteRoomSession = useDeleteRoomSession()

  const _handleDeleteMeeting = async () => {
    await deleteRoomSession()
    navigate('..')
  }

  const handleDeleteMeeting = tracked(_handleDeleteMeeting, {
    eventName: TrackEvent.ROOM_SESSION_DELETED,
    eventDetails: getRoomTrackingDetails(roomSession),
  })

  const modalBody = <div>Are you sure you want to delete this meeting?</div>

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={modalBody}
      showFooterActions
      footerPrimaryActionTitle='Delete'
      footerPrimaryActionButtonVariant='danger'
      footerPrimaryActionLoading={isDeleteRoomSessionLoading}
      onFooterPrimaryAction={handleDeleteMeeting}
    />
  )
}
